/**
 * Created by Ondra on 19.10.2016.
 */
import React from 'react';
import {List} from 'immutable';
import ProductRow from './ProductRow';
import Currency from '../components/numbers/Currency';
import CloseButton from '../components/buttons/CloseButton';
import {findFirstElementByClassInElement, isOverflowedClass,} from '../../common/lib/util';
import {isElemetVisible} from '../../common/lib/visibility';
import Percent from "../components/numbers/Percent";

class AbstractPaymentPopup extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        setPaymentItemsWithZeroDiscount: React.PropTypes.func,
        resetSelectedCashboxToDefault: React.PropTypes.func,
        resetPaymentMoney: React.PropTypes.func,
        clearDiscount: React.PropTypes.func,
        paymentChangeRadio: React.PropTypes.func,
        discountChangeRadio: React.PropTypes.func,
        selectCashbox: React.PropTypes.func,
        closePaymentPopup: React.PropTypes.func,
        moneyGivenConnetToEnd: React.PropTypes.func,
        moneyGivenAdd: React.PropTypes.func,
        discount: React.PropTypes.number,
        paymentRadio: React.PropTypes.string,
        discountRadio: React.PropTypes.string,
        moneyGiven: React.PropTypes.number,
        discountCurrency: React.PropTypes.number,
        payingInProgress: React.PropTypes.bool,
        onlineState: React.PropTypes.bool,
        paymentRadioTypes: React.PropTypes.object,
        cashboxes: React.PropTypes.object,
        selectedCashbox: React.PropTypes.object,
        defaultCashbox: React.PropTypes.object,
        discountPrice: React.PropTypes.number,
        selectedItemId: React.PropTypes.number,
        items: React.PropTypes.object
    };

    constructor(props) {
        super(props);

        this.checkMoney = this.checkMoney.bind(this);
        this.checkAndDoOrder = this.checkAndDoOrder.bind(this);
        this.getTotalPriceRound = this.getTotalPriceRound.bind(this);
        this.getTotalPricePreRound = this.getTotalPricePreRound.bind(this);
        this.scrollBy = this.scrollBy.bind(this);
        this.scrollByItem = this.scrollByItem.bind(this);
        this.setDefaulMoney = this.setDefaulMoney.bind(this);
        this.getItemsToPrint = this.getItemsToPrint.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.scrollToSelectedItem = this.scrollToSelectedItem.bind(this);
        this.changeSale = this.changeSale.bind(this);
    }

    checkAndDoOrder() {
        console.error('Method checkAndDoOrder not implemented!!');
    }

    getItemsToPrint() {
        console.error('Method getItemsToPrint not implemented!!');
    }

    getTotalPricePreRound() {
        console.error('Method getTotalPricePreRound not implemented!!');
    }

    componentWillMount() {
        this.setDefaulMoney();
    }

    componentDidMount() {
        const {setPaymentItemsWithZeroDiscount} = this.props;
        setPaymentItemsWithZeroDiscount(this.getItemsToPrint(), this.getTotalPricePreRound());
    }

    componentWillUnmount() {
        const {resetSelectedCashboxToDefault} = this.props;
        resetSelectedCashboxToDefault();
    }

    setDefaulMoney() {
        const {resetPaymentMoney, clearDiscount, paymentRadio, paymentRadioTypes} = this.props;
        if (paymentRadio === paymentRadioTypes.MONEY_GIVEN) {
            resetPaymentMoney(0);
        } else {
            clearDiscount();
        }
    }

    componentDidUpdate() {
        this.scrollToSelectedItem();
    }

    scrollToSelectedItem() {
        const {selectedItemId} = this.props;
        if (!!selectedItemId) {
            const isOverflow = isOverflowedClass('scroll');
            if (isOverflow){
                const div = document.getElementsByClassName("scroll")[0];
                if (div.getElementsByClassName('active-payment-receipt').length > 0) {
                    const activeDiv = div.getElementsByClassName('active-payment-receipt')[0];
                    if (!isElemetVisible(activeDiv)) {
                        div.scrollTop = activeDiv.offsetTop;
                    }
                }
            }
        }
    }

    scrollBy(up) {
        const {selectedItemId, paymentRadio, paymentRadioTypes} = this.props;
        const div = document.getElementsByClassName("scroll")[0];
        if (selectedItemId === null || typeof selectedItemId === 'undefined' || paymentRadio !== paymentRadioTypes.SOME_ITEM) {
            if (up) {
                div.scrollTop -= 100;
            } else {
                div.scrollTop += 100;
            }
        } else {
            this.scrollByItem(div, up);
        }
    }

    scrollByItem(parent, up) {
        const {selectedItemId, paymentChangeRadio, paymentRadioTypes} = this.props;
        let id;
        if (!!selectedItemId && parent.childNodes.length > 0) {
            const classToSelect = `item-${selectedItemId}`;
            let selectedElement = findFirstElementByClassInElement(parent, classToSelect);

            if (!!selectedElement) {
                if (up) {
                    let previousElement = selectedElement.previousSibling;
                    if (!!previousElement) {
                        id = previousElement.getAttribute('data-id');
                    }
                } else {
                    let nextElement = selectedElement.nextSibling;
                    if (!!nextElement) {
                        id = nextElement.getAttribute('data-id');
                    }
                }
            } else {
                id = getFirstItemIdInList();
            }
        } else if (parent.childNodes.length > 0) {
            id = getFirstItemIdInList();
        }

        if (typeof id !== "undefined") {
            paymentChangeRadio(paymentRadioTypes.SOME_ITEM, parseInt(id));
        }

        function getFirstItemIdInList() {
            let selectedElement = findFirstElementByClassInElement(parent, 'row');
            if (!!selectedElement) {
                return selectedElement.getAttribute('data-id');
            }
        }
    }

    getTotalPriceRound(totalPrice) {
        return Math.round(totalPrice);
    }

    checkMoney(discountPrice) {
        const {moneyGiven, payingInProgress} = this.props;
        if (payingInProgress) {
            return false;
        }
        return parseFloat(moneyGiven) === 0 || parseFloat(moneyGiven) >= parseFloat(discountPrice);
    }

    closePopup() {
        const {closePaymentPopup} = this.props;
        closePaymentPopup();
    }

    changeSale() {
        const {
            paymentRadio, paymentRadioTypes, paymentChangeRadio, discountChangeRadio, discountRadio, clearDiscount
        } = this.props;
        let radioType = '';

        if (paymentRadio === discountRadio) {
            if (paymentRadio === paymentRadioTypes.DISCOUNT) {
                radioType = paymentRadioTypes.DISCOUNT_CURRENCY;
            } else {
                radioType = paymentRadioTypes.DISCOUNT;
            }
        } else {
            radioType = discountRadio;
        }

        paymentChangeRadio(radioType);
        discountChangeRadio(radioType);
        clearDiscount();
    }

    render() {
        const {
            moneyGiven, moneyGivenAdd, defaultCashbox, selectedCashbox, moneyGivenConnetToEnd, cashboxes, onlineState,
            selectCashbox, discount, paymentRadio, paymentChangeRadio, paymentRadioTypes, selectedItemId,
            items, discountPrice, msg, discountRadio, discountCurrency
        } = this.props;

        const paperNums = List.of(100, 200, 500, 1000);
        const coinsNums = List.of(1, 2, 3, 4, 5, 6, 7, 8, 9);

        const cur = 'CZK';
        const otherCashboxes = cashboxes.filter(c => c.get('id') !== defaultCashbox.get('id'));
        const totalPricePreRound = this.getTotalPricePreRound();
        const totalPriceRound = this.getTotalPriceRound(totalPricePreRound);
        const toPay = Math.round(discountPrice);
        const toReturn = moneyGiven - toPay;

        return (
            <div id="payment" className="pagePayment">
              <div className="pagePayment-receipt">
                <section className="receipt">
                    <div className={`receipt-list list with-controls`}>
                        <div className="receipt-scroll scroll paymentScroll">
                            {items.map((item, i) =>
                                <ProductRow key={`payment-popup-item-${i}`}
                                            showDiscount={discount > 0 || item.get('discount') > 0 || [paymentRadioTypes.DISCOUNT, paymentRadioTypes.SOME_ITEM, paymentRadioTypes.DISCOUNT_CURRENCY].indexOf(paymentRadio) > -1}
                                            discount={item.get('discount')}
                                            item={item}
                                            activeClass="active active-payment-receipt"
                                            marked={selectedItemId === item.get('id')}
                                            onClick={() => paymentChangeRadio(paymentRadioTypes.SOME_ITEM, item.get('id'))}
                                            showPriceByPc/>
                            )}
                        </div>
                    </div>

                    <div className="receipt-controls controls">
                      <div className="receipt-arr">
                        <div className="boxBtn color-white" onClick={() => this.scrollBy(true)}>
                            <div className="boxBtn-inner">
                              <div className="ico-up"></div>
                            </div>
                        </div>
                      </div>
                      <div className="receipt-arr">
                        <div className="boxBtn color-white" onClick={() => this.scrollBy(false)}>
                            <div className="boxBtn-inner">
                              <div className="ico-down"></div>
                            </div>
                        </div>
                      </div>
                    </div>

                    <div className="receipt-sum suma">
                        <span className="receipt-sum-table">Celkem</span>
                        {(discount > 0 || [paymentRadioTypes.DISCOUNT, paymentRadioTypes.SOME_ITEM, paymentRadioTypes.DISCOUNT_CURRENCY].indexOf(paymentRadio) > -1) &&
                            <span className="receipt-sum-price" style={{width: 150, textAlign: 'right'}}>
                                <Currency value={Number(discountRadio === paymentRadioTypes.DISCOUNT ? discountPrice : toPay )} currency={cur}/>
                            </span>
                        }
                        <span className="receipt-sum-price">
                            <Currency value={totalPriceRound} currency={cur}/>
                        </span>
                    </div>

                </section>
              </div>
              <div className="pagePayment-numpad">
                <section className="numpad">
                    {coinsNums.map(coin =>
                      <div className="numpad-key" key={`payment-popup-coin-${coin}`}>
                        <div className={`boxBtn color-green text-xl text-b`}
                             onClick={() => moneyGivenConnetToEnd(coin)}>
                            <div className="boxBtn-inner"><span>{coin}</span></div>
                        </div>
                      </div>
                    )}
                  <div className="numpad-key">
                    <div className="boxBtn color-greenLight text-xl text-b" onClick={() => this.setDefaulMoney()}>
                        <div className="boxBtn-inner">C</div>
                    </div>
                  </div>
                  <div className="numpad-key">
                    <div className="boxBtn color-green text-xl text-b" onClick={() => moneyGivenConnetToEnd(0)}>
                        <div className="boxBtn-inner">0</div>
                    </div>
                  </div>
                </section>
              </div>
              <section className="pagePayment-bills">
                  {paperNums.map(paper =>
                    <div className="pagePayment-bills-key" key={`payment-popup-paper-${paper}`}>
                      <div
                          className={`boxBtn color-greenLight text-lr ${[paymentRadioTypes.DISCOUNT, paymentRadioTypes.SOME_ITEM, paymentRadioTypes.DISCOUNT_CURRENCY].indexOf(paymentRadio) > -1 ? 'disabled' : ''}`}
                          onClick={() => moneyGivenAdd(paper)}>
                          <div className="boxBtn-inner"><span>{paper}</span></div>
                      </div>
                    </div>
                  )}
              </section>
                <section className="pagePayment-type">

                    {!!defaultCashbox &&
                      <div className="pagePayment-type-key">
                        <div className={`boxBtn text-left text-l color-${selectedCashbox.get('id') === defaultCashbox.get('id') ? 'red' : 'white'}`}
                             onClick={() => selectCashbox(defaultCashbox.get('id'))}>
                            <div className="boxBtn-inner">
                                <span>{defaultCashbox.get('name')}</span>
                            </div>
                        </div>
                      </div>
                    }

                    {!!otherCashboxes && otherCashboxes.map((c, i) =>
                      <div className="pagePayment-type-key" key={`cashbox-${c.get('id')}`}>
                        <div className={`boxBtn text-left text-l color-${selectedCashbox.get('id') === c.get('id') ? 'red' : 'white'}`}
                             onClick={() => selectCashbox(c.get('id'))}>
                            <div className="boxBtn-inner">
                                <span>{c.get('name')}</span>
                            </div>
                        </div>
                      </div>
                    )}

                </section>
                <section className="pagePayment-sales">
                  <div className="pagePayment-sales-key">
                    <div className={`boxBtn color-white text-l ${[paymentRadioTypes.DISCOUNT, paymentRadioTypes.DISCOUNT_CURRENCY].indexOf(paymentRadio) > -1 ? 'is-selected' : ''}`}
                         onClick={this.changeSale}>
                        <div className="boxBtn-inner">
                            <div className="boxBtn-line">
                                <span>
                                    {msg.payment.sale}&nbsp;
                                    {discountRadio === paymentRadioTypes.DISCOUNT && '%'}
                                    {discountRadio === paymentRadioTypes.DISCOUNT_CURRENCY && "Kč"}
                                </span>
                                <span>
                                    {discountRadio === paymentRadioTypes.DISCOUNT &&
                                        <Percent value={discount} />
                                    }
                                    {discountRadio === paymentRadioTypes.DISCOUNT_CURRENCY &&
                                        <Currency currency={cur} value={discountCurrency} />
                                    }
                                </span>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div className="pagePayment-sales-key">
                  </div>
                  <div className="pagePayment-sales-key">
                    <div className={`boxBtn color-white text-l ${paymentRadio === paymentRadioTypes.MONEY_GIVEN ? 'is-selected' : ''}`}
                         onClick={() => paymentChangeRadio(paymentRadioTypes.MONEY_GIVEN)}>
                        <div className="boxBtn-inner">
                            <div className="boxBtn-line">
                                <span>{msg.payment.paid}</span>
                                <span><Currency value={moneyGiven} currency={cur}/></span>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div className="pagePayment-sales-key view-third"></div>
                  <div className="pagePayment-sales-key view-third">
                    <div className="boxBtn color-white" onClick={() => this.closePopup()}>
                        <CloseButton/>
                    </div>
                  </div>
                </section>
                <section className="pagePayment-totals">
                  <div className="pagePayment-totals-key">
                    {discount > 0 &&
                        <div className="boxBtn text-black text-l">
                            <div className="boxBtn-inner">
                                <div className="boxBtn-line">
                                    <span>{msg.payment.afterSale}</span>
                                    <Currency value={toPay} currency={cur}/>
                                </div>
                            </div>
                      </div>
                    }
                    </div>
                  <div className="pagePayment-totals-key">
                    <div className="boxBtn text-black text-l">
                        <div className="boxBtn-inner">
                            <div className="boxBtn-line">
                                <span>{msg.payment.toPayment}</span>
                                <span className="amount">
                                  <div className="pagePayment-totals-toPay">
                                    <Currency value={toPay} currency={cur}/>
                                  </div>
                                </span>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div className="pagePayment-totals-key">
                    <div className="boxBtn text-black text-l">
                        <div className="boxBtn-inner">
                            <div className="boxBtn-line">
                                <span>{msg.payment.return}</span>
                                <Currency value={toReturn < 0 ? 0 : toReturn} currency={cur}/>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div className="pagePayment-totals-key">
                    <div className={`boxBtn color-red text-up text-lr ${this.checkMoney(toPay) ? '' : 'disabled'}`}
                         onClick={() => this.checkAndDoOrder(toPay)}>
                        <div className="boxBtn-inner">
                            <span>
                                {msg.payment.sell}
                                {!onlineState && ' offline'}
                            </span>
                        </div>
                    </div>
                  </div>
                </section>
            </div>
        );
    }

}

export default AbstractPaymentPopup;



// WEBPACK FOOTER //
// ./src/browser/paymentPopup/AbstractPaymentPopup.js